// Loaded beside the shell bundle by templates/pages/register-kombo.html. Both steps post
// without this bundle; htmx swaps the card in place instead of reloading the page.
import "htmx.org"

const CARD = "register-card"
const REVEAL_MS = 3000
const PRIMARY = [
  "bg-brand-500",
  "hover:bg-brand-600",
  "border-brand-500",
  "hover:border-brand-600",
  "focus:ring-brand-500/[.24]",
]
const DESTRUCTIVE = [
  "bg-error-500",
  "hover:bg-error-600",
  "border-error-500",
  "hover:border-error-600",
  "focus:ring-error-500/[.24]",
]

let revealTimeout

function card() {
  return document.getElementById(CARD)
}

function submitButton() {
  return card()?.querySelector("button[type='submit']")
}

// One `$pageview` per step shown and per error shown, the count Data's signup numbers
// rest on. The server-rendered page captures the pageview for its first step.
function track(tracking) {
  const posthog = window.posthog
  if (typeof posthog === "undefined") {
    return
  }
  const props = posthog.persistence?.props
  const page = { ...props?.page, ...tracking.page }
  if (props && tracking.registration) {
    posthog.register({
      user: {
        ...props.user,
        registration: { ...props.user?.registration, ...tracking.registration },
      },
    })
  } else if (props) {
    posthog.register({ page })
  }
  posthog.capture("$pageview", { page })
}

function showRevealButtons() {
  for (const button of card()?.querySelectorAll("[data-password-reveal]") ?? []) {
    button.hidden = false
  }
}

function currentTracking() {
  const payload = document.getElementById("register-tracking")
  return payload ? JSON.parse(payload.textContent) : null
}

function setPending(pending) {
  const button = submitButton()
  if (!button) {
    return
  }
  button.disabled = pending
  if (pending) {
    button.dataset.label = button.textContent.trim()
    button.textContent = `${button.dataset.label}...`
  } else if (button.dataset.label) {
    button.textContent = button.dataset.label
  }
}

function showFailure(name) {
  const form = card()?.querySelector("form")
  if (!form) {
    return
  }
  setPending(false)
  const button = submitButton()
  button.classList.remove(...PRIMARY)
  button.classList.add(...DESTRUCTIVE)
  const error = form.querySelector("[data-general-error]")
  error.querySelector("span").textContent =
    name === "network" ? form.dataset.errorNetwork : form.dataset.errorServer
  error.hidden = false

  const tracking = currentTracking()
  if (tracking) {
    track({
      page: tracking.page,
      registration: { is_error: true, is_success: false, error: name, field_errors: {} },
    })
  }
}

document.addEventListener("click", (event) => {
  const reveal = event.target.closest("[data-password-reveal]")
  if (!reveal) {
    return
  }
  const input = reveal.parentElement.querySelector("input")
  input.type = input.type === "password" ? "text" : "password"
  reveal.setAttribute("aria-pressed", String(input.type === "text"))
  clearTimeout(revealTimeout)
  revealTimeout = setTimeout(() => {
    input.type = "password"
    reveal.setAttribute("aria-pressed", "false")
  }, REVEAL_MS)
})

showRevealButtons()

document.addEventListener("htmx:before:request", () => setPending(true))

document.addEventListener("htmx:after:swap", (event) => {
  if (event.target.id !== CARD) {
    return
  }
  const tracking = currentTracking()
  if (tracking) {
    track(tracking)
  }
  showRevealButtons()
  const field =
    card().querySelector("[aria-invalid='true']") ??
    card().querySelector("input:not([type='hidden'])") ??
    card().querySelector("h2[tabindex='-1']")
  field?.focus()
})

// htmx 4 fires `htmx:response:error` for a 4xx/5xx and `htmx:error` when the request,
// the response handling or the swap throws.
document.addEventListener("htmx:response:error", () => showFailure("server-error"))
document.addEventListener("htmx:error", () => showFailure("network"))
